import { render, staticRenderFns } from "./ServicesHomeTwo.vue?vue&type=template&id=1a416ca5&"
import script from "./ServicesHomeTwo.vue?vue&type=script&lang=js&"
export * from "./ServicesHomeTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports